import React from "react";
import { Box, CircularProgress } from "@mui/material";

const LoadingIndicator = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    position="fixed"
    top={0}
    left={0}
    width="100%"
    height="100%"
    backgroundColor="rgba(0, 0, 0, 0.5)"
    zIndex={9999}
  >
    <CircularProgress color="primary" />
  </Box>
);

export default LoadingIndicator;
